// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2je9h","select":"Header_select__2cvWr","clinic":"Header_clinic__irBYp"};